module.exports = __webpack_public_path__ + "static/feedmill-e7b43b01b2258c02c2239f7407ab3925.png";